import React from 'react'


import parse from 'html-react-parser'
import CanvasJSReact from '../canvasjs-3.7/canvasjs.react';
import {BiobankInput} from "../components/BiobankRequest";
import {AssayInput} from "../components/AssayRequest";
import util from "../lib/chart_functions";
import * as PropTypes from "prop-types";
import i18n from "i18next";

const CanvasJSChart = CanvasJSReact.CanvasJSChart;

CanvasJSChart.propTypes = {
    options: PropTypes.shape({
        data: PropTypes.any,
        exportEnabled: PropTypes.bool,
        theme: PropTypes.string,
        title: PropTypes.any,
        animationEnabled: PropTypes.bool
    })
};
export default class BiobankContainer extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            response: '[]',
            status_code: "200",
            selector_names: ['type_list', 'collection_list'],
            lists: [],
            checkeds: []
        };
    }

    componentDidMount() {
        // GET request using fetch with set headers
        const headers = {'Access-Control-Request-Method': 'GET'}
        let url = ""
        url += `full=true&`
        url += `k_cutoff=5&`
        url += `use_similarity=false`
        fetch(`${process.env.REACT_APP_BACK_END}/biobanks/?${url}`, {headers})
            .then(response => {
                this.setState({status_code: response.status})
                return response.text()
            })
            .then(data => this.setState({response: data}));
    }

    createNewRequest = (input) => {
        const headers = {'Content-Type': 'application/json'}
        const type_input = encodeURIComponent(input.type_input);
        const collection_input = encodeURIComponent(input.collection_input);
        const use_similarity_input = encodeURIComponent(input.similarity_input);
        const k_cutoff_input = encodeURIComponent(input.k_phenos_input);
        const use_similarity_bool = encodeURIComponent(input.use_similarity_checked[0]);
        let url = ""
        url += `type=${type_input}&`
        url += `collection=${collection_input}&`
        url += `similarity_cutoff=${use_similarity_input / 100}&`
        url += `k_cutoff=${k_cutoff_input}&`
        url += `use_similarity=${use_similarity_bool}`
        console.log(url)
        fetch(`${process.env.REACT_APP_BACK_END}/biobanks/?${url}`,
            {headers})
            .then(response => {
                this.setState({status_code: response.status})
                return response.text()
            })
            .then(data => this.setState({response: data}));

    }


    render() {
        const {response} = this.state
        const {status_code} = this.state
        let {lists} = this.state
        let {checkeds} = this.state
        const {selector_names} = this.state

        const htmls = []
        let msg = ""
        let phenotypes_content = "<div></div>"
        const ERRORS = ["assays_zero", "patients_zero", "organizations_zero", "collections_zero", "merge_zero"]


        if (status_code === 200 && !ERRORS.includes(response)) {
            const parsed_json = JSON.parse(response)

            let gwases = parsed_json["gwases"]
            let phenotypes = parsed_json["phenotypes"]
            let ncbi = parsed_json["ncbi"]
            const selectors = parsed_json["selectors"]

            lists = []
            checkeds = []
            lists['age_settings_list'] = ['age_na', 'age_nb']
            checkeds['age_settings_list'] = [true, true]
            for (const s in selector_names) {
                let s_name = selector_names[s];
                let list = []
                let checked = []
                if (typeof selectors !== 'undefined') {
                    list = selectors[s_name]
                    checked = Array(list.length).fill(true);
                }
                lists[s_name] = list;
                checkeds[s_name] = checked;

            }
            let categories = ['category_fg', 'category_ukb'];

            htmls.push(<h3 className="mt-3">
                {i18n.t("found_phenotypes_header")}
            </h3>)
            if (typeof phenotypes !== 'undefined') {
                for (let i = 0; i < categories.length; i++) {
                    htmls.push(<h5 className="mt-2">
                        {i18n.t(`title_${categories[i]}`)}:
                    </h5>)
                    htmls.push(util.jsonToList(phenotypes[categories[i]]))

                }
            }

            categories = ['category_fg', 'category_ukb', 'category_meta'];
            htmls.push(<h3 className="mt-3">
                {i18n.t("found_gwas_header")}
            </h3>)
            if (typeof gwases !== 'undefined') {
                for (let i = 0; i < categories.length; i++) {
                    htmls.push(<h5 className="mt-2">
                        {i18n.t(`title_${categories[i]}`)}:
                    </h5>)
                    htmls.push(util.jsonToTable(gwases[categories[i]]));
                }
            }

            htmls.push(<h3 className="mt-3">
                {i18n.t("found_ncbi")}
            </h3>)
            if (typeof ncbi !== 'undefined') {
                htmls.push(util.jsonToList(ncbi));

            }

        } else {
            msg = response
        }
        return (<div className="main-container container">
            <div className="row">
                <div className="col-4">
                    <BiobankInput createNewRequest={this.createNewRequest}
                                  collection={lists['collection_list']}
                                  collection_checked={checkeds['collection_list']}
                                  type={lists['type_list']}
                                  type_checked={checkeds['type_list']}
                    />
                </div>
                <div className="col-8">
                    {i18n.t(msg)}
                    {htmls}
                </div>
            </div>
        </div>);
    }

}